import React from 'react'
import { string } from 'prop-types'
import { css } from '@emotion/react'

import ProductLogoIcon from '@/assets/icons/product-logo.inline.svg'
import mediaQueries from '@/layout/media-queries'

const logoCss = css`
  width: 120px;
  height: 30px;
  margin-top: 9px;

  ${mediaQueries.mediumScreen()} {
    width: 120px;
    height: 50px;
    margin-top: 8px;
  }
`

const ProductLogo = ({ className }) => (
  <a
    alt={process.env.GATSBY_PRODUCT_LABEL}
    rel="noopener noreferrer"
    href={process.env.GATSBY_PRODUCT_WEBSITE_URL}
  >
    <ProductLogoIcon css={logoCss} className={className} />
  </a>
)

ProductLogo.propTypes = {
  className: string,
}

export default ProductLogo
